export default {
  name: "Website",
  width: 32,
  height: 32,
  viewBox: "0 0 32 32",
  path: {
    d:
      "M27 3H5c-1.1 0-2 .9-2 2v22c0 1.1.9 2 2 2h22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 2v4H5V5h22zM5 11h4v16H5V11zm6 16V11h16v16H11zm6-20c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm3 0c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1zm3 0c0-.55.45-1 1-1s1 .45 1 1-.45 1-1 1-1-.45-1-1z",
  },
}
